import { InputLabel, OutlinedInput } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TextH2 = styled("h2")`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #000000;
`;

type AccountFormControlProps = {
  percentage?: string;
};

export const AccountDiv = styled("div")<AccountFormControlProps>`
  width: ${(props) => (props.percentage ? props.percentage : "100%")};
  height: 250px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 6px;
  margin-right: 10px;
`;

export const CompanyBaseboardEndDiv = styled("div")`
  display: flex;
  justify-content: flex-end;
`;

export const AccountPBlack = styled("span")`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #717171;
`;

export const AccountOutlinedInputFile = styled(OutlinedInput)`
  background-color: #ffffff;
  border-radius: 6px;
  display: none;
`;

export const AccountInputLabel = styled(InputLabel)`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #717171;
  cursor: pointer;
`;

export const AccountForm = styled("form")`
  align-items: center;
`;

export const AccountContentButton = styled("div")`
  display: flex;
  justify-content: flex-end;
`;

export const AccountButton = styled("button")`
  border: none;
  margin-top: 30px;
  padding: 15px 60px;
  gap: 15px;
  background: #ffbb00;
  border: 1px solid #ffbb00;
  border-radius: 6px;
  background-color: #ffbb00;
  box-shadow: rgba(50, 50, 93, 0.1) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.08) 0px 1px 3px 0px;
  border-radius: 6px;
  cursor: pointer;

  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: #1f1f1f;

  &:hover {
    background-color: #b68500;
  }
`;

export const AccountDownloadButton = styled("button")`
  border: none;
  width: 258px;
  height: 42px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: #6257b8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 32px;
  background: #ffffff;

  border: 1px solid #6257b8;
  border-radius: 6px;

  &:hover {
    background-color: #5042b8;
    color: #ffffff;
    a {
      background-color: #5042b8;
      color: #ffffff;
    }
  }
  a:hover {
    background-color: #5042b8;
    color: #ffffff;
  }
`;

export const AccountDownloadA = styled("a")`
  text-decoration: none;
`;
